/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/

import { asMessageRenderer } from '@post-office/placement-common';
import jiraPulsar from '@post-office/team-export--jira-pulsar/placements/in-app/jira-top-banner/render';
import postOfficeTemplate from '@post-office/team-export--post-office-template/placements/in-app/jira-top-banner/render';

export const renderer = { ...jiraPulsar, ...postOfficeTemplate };

export const { initializeMessageRenderer, MessageRenderer } = asMessageRenderer(renderer);
